import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/wordle.json";
import fr from "@/locales/fr/puzzle-types/wordle.json";

export const WORDLE_NS = "puzzle-types/wordle";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerWordleTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", WORDLE_NS))
    i18n.addResourceBundle("en", WORDLE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", WORDLE_NS))
    i18n.addResourceBundle("fr", WORDLE_NS, fr, true, true);
}
